import React, { useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import ProjectTable from "../../components/Projects/ProjectTable";
import ProjectFilters from "../../components/Projects/ProjectFilters";
import ProjectModal from "../../Modal/projects/ProjectModal";
import useProjects from "../../Hooks/useProjects";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";

const ProjectsList = () => {
  const [filters, setFilters] = useState({
    search: "",
    projectType: "",
    projectStatus: "",
  });
  const [selectedProject, setSelectedProject] = useState(null);
  const [mode, setMode] = useState("create");
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();
  console.log("hd")
  const { projects, loading, fetchProjects } = useProjects(filters);

  return (
    <div className="page-content">
      <Breadcrumbs title="Projects" breadcrumbItem="All Projects" />
      <ProjectFilters onAdd={() => {setMode("create");setSelectedProject(null);setModal(true);}} filters={filters} setFilters={setFilters} />
      <ProjectTable projects={projects} loading={loading} fetchProjects={fetchProjects} onView={(project) => { setMode("view"); setSelectedProject(project); setModal(true); }} onEdit={(project) => { setMode("edit"); setSelectedProject(project); setModal(true); }} />
      <ProjectModal isOpen={modal} toggle={() => setModal(false)} mode={mode}  selectedProject={selectedProject} onSuccess={() => fetchProjects()} />
    </div>
  );
};

export default ProjectsList;